import { render } from "./inReview.vue?vue&type=template&id=0672631e"
import script from "./inReview.vue?vue&type=script&lang=js"
export * from "./inReview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__